import EntriesTable from './EntriesTable';

export default EntriesTable;
